import theme from "./Theme";

export const THEME = theme;